<template>
    <div class="user_orders_Settings">

        <b-tabs pills card vertical class="">
            <b-tab title-link-class="" :key="item.comp"  :active="item.is_active"  v-for="(item,idx) in pwa_res">
                <template slot="title">
                    <div class="fs-lg px-4 text-center ">
                        {{item.name }}
                    </div>
                </template>

                <b-card-text>
                    <component :client_id="user.client_id" :pwa="pwa" v-bind:is="item.comp" ></component>
                </b-card-text>
            </b-tab>
        </b-tabs>

    </div>
</template>

<script>

import pwa_article_description from "./texts/pwa_article_description.vue";
import pwa_article_about from "./texts/pwa_article_about.vue";
import pwa_article_delivery from "./texts/pwa_article_delivery.vue";
import pwa_article_conditions from "./texts/pwa_article_conditions.vue";
import pwa_article_privacy from "./texts/pwa_article_privacy.vue";

export default {
    name: "pwa_texts",
    props: {
        user: {
            type: Object
        },
        pwa : {
            type:Object
        }
    },
    components: {
        pwa_article_description,
        pwa_article_about,
        pwa_article_delivery,
        pwa_article_conditions,
        pwa_article_privacy
    },

    data() {
        return {
            is_loaded : false,
            is_load: false,

        }
    },
    methods: {
        on_loading_files(state) {
            this.is_load = state;
        }
    },

    computed : {
        pwa_res () {
            return [
                {
                    'name' : this.__t('pwa_description'),
                    'comp' : 'pwa_article_description',
                    'is_active' : true,
                },
                {
                    'name' : this.__t('pwa_about'),
                    'comp' : 'pwa_article_about',
                    'is_active' : false,
                },
                {
                    'name' : this.__t('pwa_delivery'),
                    'comp' : 'pwa_article_delivery',
                    'is_active' : false,
                },
                {
                    'name' : this.__t('pwa_conditions'),
                    'comp' : 'pwa_article_conditions',
                    'is_active' : false,
                },
                {
                    'name' : this.__t('pwa_privacy'),
                    'comp' : 'pwa_article_privacy',
                    'is_active' : false,
                },
            ]
        }

    }

}
</script>

<style scoped>

</style>
